module.exports = __webpack_public_path__ + "img/icon-search-mobile.754a4486.svg";